import { render, staticRenderFns } from "./FooterSivoa.vue?vue&type=template&id=92b5fbb4&scoped=true&"
import script from "./FooterSivoa.vue?vue&type=script&lang=js&"
export * from "./FooterSivoa.vue?vue&type=script&lang=js&"
import style0 from "./FooterSivoa.vue?vue&type=style&index=0&id=92b5fbb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b5fbb4",
  null
  
)

export default component.exports